import React, { useState, useEffect } from 'react';
import Notification from './Notification';
import { notificationService, NotificationItem } from '../../services/notificationService';

const NotificationContainer: React.FC = () => {
  const [notifications, setNotifications] = useState<NotificationItem[]>([]);

  useEffect(() => {
    // Suscribirse al servicio de notificaciones
    const unsubscribe = notificationService.subscribe(setNotifications);
    
    return () => {
      unsubscribe();
    };
  }, []);

  const handleClose = (id: string) => {
    notificationService.removeNotification(id);
  };

  return (
    <div className="fixed top-0 right-0 z-50 p-4 space-y-4">
      {notifications.map((notification) => (
        <Notification
          key={notification.id}
          id={notification.id}
          type={notification.type}
          title={notification.title}
          message={notification.message}
          duration={notification.duration}
          onClose={handleClose}
        />
      ))}
    </div>
  );
};

export default NotificationContainer;
export {};